import { alertConstants } from '../constants';
import  React  from "react";
import {removeAllNotifications,createNotification, NOTIFICATION_TYPE_SUCCESS, NOTIFICATION_TYPE_ERROR} from 'react-redux-notify';
export const alertActions = {
    success,
    error,
    clear
};

function success(message) {

    const myNotification = {
      
        message: message,
        type: NOTIFICATION_TYPE_SUCCESS,
        duration: 2000,
        canDismiss: true,
        icon: <i className="fa fa-check" />,
        showCloseAllBtn: false,
    };


    return dispatch => {

        dispatch(createNotification(myNotification));

        return { type: alertConstants.SUCCESS, message };

    }
    
}

function error(message) {
    
    const myNotification = {
       
        message: message,
        type: NOTIFICATION_TYPE_ERROR,
        duration: 2000,
        canDismiss: true,
        icon: <i className="fa fa-check" />,
        showCloseAllBtn: false,
    };


    return dispatch => {

        dispatch(createNotification(myNotification));

        return { type: alertConstants.ERROR, message };

    }
}

function clear() {

    
    return dispatch => {

       // dispatch(removeAllNotifications(true));

        return { type: alertConstants.CLEAR };

    }
    
}